module.exports = __webpack_public_path__ + "static/media/stege-min.223d40d0.png";